module.exports = __webpack_public_path__ + "static/media/play-store-it.d9adcf7b.svg";